import Base from 'app/views/base';

import { presentModal, closeModal } from 'utils/modal';

export default Base.extend({
  className: 'modal fade',
  attributes: {
    tabindex: '-1',
  },

  show() {
    this.delegateEvents();
    this.render();
    this.modal = presentModal(this.$el, {});
    return this;
  },

  close(optionalEvent) {
    if (optionalEvent) {
      optionalEvent.preventDefault();
    }

    closeModal(this.modal);
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/base_modal.js